import { Box, Image } from '@gassan-ui'
import { Icon } from '@rolex-ui'
import React, { FC, useEffect, useRef, useState } from 'react'
import * as S from './elements'
import { getClosestIndex } from '../utils'

let timer

interface Props {
  activeIndex?: number
  onChange?: (index: number) => void
  title: string
  sources: string[]
  modelGradient?: string[]
}

const ProductSlider: FC<Props> = ({ activeIndex, onChange, title, sources, modelGradient }) => {
  const ref = useRef<HTMLDivElement>(null)

  // Seperate the nav index state from the gallery index state
  // to prevent rerenders based on scroll position
  const [, setNavIndex] = useState(0)

  // If activeIndex changes, smooth scroll to it
  // e.g. if a users presses a thumbnail or the mobile navigation
  useEffect(() => {
    // Sync nav index
    setNavIndex(activeIndex)

    if (ref && ref.current) {
      ref.current.scrollTo({
        top: 0,
        left: activeIndex * ref.current.clientWidth,
        behavior: 'smooth'
      })
    }
  }, [activeIndex])

  const handleTouchEnd = () => {
    if (timer) {
      clearTimeout(timer)
    }
    // Set a timeout to ensure that the scroll animation is finished or almost finished
    timer = setTimeout(() => {
      if (ref && ref.current) {
        const closestIndex = getClosestIndex(ref.current)
        // Update the nav index state with the found index
        setNavIndex(closestIndex)
        onChange(closestIndex)
      }
    }, 500)
  }

  const handlePrev = () => onChange(activeIndex === 0 ? sources.length - 1 : activeIndex - 1)
  const handleNext = () => onChange(activeIndex === sources.length - 1 ? 0 : activeIndex + 1)

  return (
    <>
      <Box
        position="relative"
        width="100%"
        maxWidth={{ large: '600px' }}
        backgroundImage={modelGradient && { _: `url(${modelGradient[0]})`, large: 'none' }}
        backgroundSize="cover"
        backgroundRepeat="no-repeat"
      >
        <S.NavButton direction="left" onClick={handlePrev}>
          <Icon icon="chevron-left"></Icon>
        </S.NavButton>
        <S.Slider ref={ref} onTouchEnd={handleTouchEnd}>
          {sources.map((src, index) => (
            <S.Slide key={src}>
              <Image
                alt="title"
                sources={[src]}
                placeholderSrc="https://placehold.it/20x20"
                loading={index === 0 ? 'eager' : 'delayed'}
                width="100%"
                height="100%"
                position="absolute"
              />
            </S.Slide>
          ))}
        </S.Slider>
        <S.NavButton direction="right" onClick={handleNext}>
          <Icon icon="chevron-right"></Icon>
        </S.NavButton>
      </Box>
    </>
  )
}

export default ProductSlider
